import type MP4Box from 'mp4box';
import { MAX_FILE_SIZE } from '../../constants';
import type { AddError } from '../../types/upload-video';
import { VALIDATIONS } from '../../types/upload-video';

const validateFileSize = (info: MP4Box.Mp4BoxInfo, addError: AddError): void => {
  const [videoTrack] = info.videoTracks;
  if (videoTrack.size > MAX_FILE_SIZE) {
    addError(VALIDATIONS.MAX_FILE_SIZE);
  }
};

export default validateFileSize;
